// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Classnames$GearCalculator = require("../Utils/Classnames.bs.js");

function Menu(Props) {
  var children = Props.children;
  var className = Props.className;
  return React.createElement("aside", {
              className: Classnames$GearCalculator.make(/* :: */[
                    "menu",
                    /* :: */[
                      Classnames$GearCalculator.unpack(className),
                      /* [] */0
                    ]
                  ])
            }, children);
}

var make = Menu;

exports.make = make;
/* react Not a pure module */
